import { map } from 'ramda'

import {
  PostProceedBodyType,
  NormalizedPostProceedBody,
} from 'features/checkout/duck/operations/postProceed/prepareProceedBody/paymentProviders'
import checkoutSelectors from 'features/checkout/duck/selectors'
import { splitDateOfBirth } from 'helpers/dateOfBirth'
import { RootState } from 'redux/types'

interface NormalizePostProceedBodyArgs {
  state: RootState
  body: PostProceedBodyType
  joinClubParams?: {
    dateOfBirth: string
  }
}

export function normalizePostProceedBody({
  state,
  body,
  joinClubParams,
}: NormalizePostProceedBodyArgs): NormalizedPostProceedBody {
  let normalizedBody = body as NormalizedPostProceedBody

  if (joinClubParams) {
    normalizedBody = {
      ...normalizedBody,
      joinClub: true,
      ...map(Number, splitDateOfBirth(joinClubParams.dateOfBirth)),
    }
  }

  const vatNumber = checkoutSelectors.getVatNumber(state)
  const vatInvoiceType = checkoutSelectors.getVatInvoiceType(state)

  if (vatNumber) {
    normalizedBody = {
      ...normalizedBody,
      vat: vatNumber,
    }
  }
  if (vatInvoiceType) {
    normalizedBody = {
      ...normalizedBody,
      invoiceType: vatInvoiceType,
    }
  }

  return normalizedBody
}
